import { render, staticRenderFns } from "./RefineUpdatesList.vue?vue&type=template&id=3b3be556"
import script from "./RefineUpdatesList.vue?vue&type=script&lang=js"
export * from "./RefineUpdatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports